import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { Vector2 } from 'three'
import { KVPolygon, RolodexEntryPatchJson } from 'types'

import { KVMessageDef } from './index'

export function getNewPolygonMessage() {
  return {
    type: 'newPolygon',
    requiredData: ['polygonId'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      const polygon = KVPolygon.fromJSON(json)

      if (kv.polygons) {
        kv.polygons.push(polygon)
      }
      kv.setPolygons(kv.polygons)

      if (kv.mouseTrackerRef.current) {
        const kvElementRect = kv.videoParent.current?.getBoundingClientRect()
        kv.setPopupMenuStartPosition(
          new Vector2(
            kv.mouseTrackerRef.current.x + 30 - (kvElementRect?.left ?? 0),
            kv.mouseTrackerRef.current.y - 30 - (kvElementRect?.top ?? 0)
          )
        )
      }
      kv.setSelectedMarkup(polygon)

      // Track polygon in rolodex
      const patchData: RolodexEntryPatchJson = {
        id: kv.kestrelModel?.id ?? '',
        data: {
          polygons: kv.polygons?.map((p) => KVPolygon.toJSON(p)) ?? [],
        },
      }
      kv.rolodexPatch([patchData])
    },
  } as KVMessageDef
}
